/**
 * Tier 2 — Weekly Attestation by the Depot Manager (spec §6.1, §6.4).
 * The manager attests the exact ledger content: each referenced daily return
 * is identified by its digest, so the attestation binds to bytes, not to a
 * mutable row. A weekly attestation may only reference RECONCILED or
 * ACCEPTED_WITH_JUSTIFICATION dailies (§5.2, §6.4-1/2).
 */
export const ARTEFACT_WEEKLY_ATTESTATION = "WEEKLY_ATTESTATION";
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const ID_RE = /^[A-Za-z0-9._-]+$/;
/** date + n days, pure string math on UTC — no timezone drift */
export function addDays(isoDate, n) {
    const d = new Date(isoDate + "T00:00:00Z");
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
}
export function validateWeeklyAttestation(w) {
    const e = [];
    if (w.artefactType !== ARTEFACT_WEEKLY_ATTESTATION)
        e.push("artefactType must be WEEKLY_ATTESTATION");
    if (!Number.isSafeInteger(w.version) || w.version < 1)
        e.push("version must be >= 1");
    if (!ID_RE.test(w.depotId))
        e.push("depotId invalid");
    if (!DATE_RE.test(w.weekStart))
        e.push("weekStart must be YYYY-MM-DD");
    if (!Array.isArray(w.dailyRefs) || w.dailyRefs.length === 0)
        e.push("dailyRefs must be non-empty");
    const weekEnd = DATE_RE.test(w.weekStart) ? addDays(w.weekStart, 6) : "";
    const seen = new Set();
    (w.dailyRefs ?? []).forEach((ref, i) => {
        if (!DATE_RE.test(ref.date))
            e.push(`dailyRefs[${i}].date must be YYYY-MM-DD`);
        else if (weekEnd && (ref.date < w.weekStart || ref.date > weekEnd))
            e.push(`dailyRefs[${i}].date ${ref.date} outside week ${w.weekStart}..${weekEnd}`);
        if (!ID_RE.test(ref.busRegistrationNo))
            e.push(`dailyRefs[${i}].busRegistrationNo invalid`);
        if (!/^[0-9a-f]{64}$/.test(ref.digestSha256Hex))
            e.push(`dailyRefs[${i}].digestSha256Hex must be 32-byte hex`);
        if (!Number.isSafeInteger(ref.version) || ref.version < 1)
            e.push(`dailyRefs[${i}].version must be >= 1`);
        const k = ref.date + "/" + ref.busRegistrationNo;
        if (seen.has(k))
            e.push(`duplicate dailyRef for ${k}`);
        seen.add(k);
    });
    return e;
}
